export default __webpack_public_path__ + "06f6bd113d98c24008d92f30e0d2e8ee.svg";